export type Opts = {
  path: string
  payload: {
    [key: string]: any
  }
}

/**
 * @description
 * Функция предназначена для добавления GET параметров в запрос, исключая невалидные значения.
 * Примеры работы можно посмотреть в тестах.
 * Работает только с примитивными значениями
 */

export function getConcatOptionGET(opts: Opts) {
  let { path } = opts
  const validEntries = Object.entries(opts.payload).filter(([, value]) => typeof value !== 'undefined' && value !== null && value !== '')

  if (path.at(-1) !== '/') {
    path += '/'
  }

  validEntries.forEach(([key, value], index) => {
    if (index === 0) {
      path += '?'
    }

    path += `${key}=${value}`

    if (index !== validEntries.length - 1) {
      path += '&'
    }
  })

  return path
}
